import * as React from 'react';

var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle2, _circle3, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgMana = function SvgMana(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 60,
        cy: 60,
        r: 60,
        fill: "url(#paint0_linear_1733_3230)"
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_1733_3230)",
        d: "M42.51 39v45h37.5z"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M5.01 84h37.5V39z"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#FC9965",
        d: "M12 96a61.5 61.5 0 0 0 12 12h72a61.5 61.5 0 0 0 12-12z"
    })), _path4 || (_path4 = /*#__PURE__*/ React.createElement("path", {
        fill: "#FF2D55",
        d: "M24 108c10.02 7.53 22.5 12 36 12s25.98-4.47 36-12z"
    })), _path5 || (_path5 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint2_linear_1733_3230)",
        d: "M80.49 63v33H108z"
    })), _path6 || (_path6 = /*#__PURE__*/ React.createElement("path", {
        fill: "#FFBC5B",
        d: "M80.49 84H5.01c1.86 4.29 4.23 8.31 6.99 12h68.52V84z"
    })), _path7 || (_path7 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M53.01 96h27.48V63z"
    })), _circle2 || (_circle2 = /*#__PURE__*/ React.createElement("circle", {
        cx: 80.49,
        cy: 39,
        r: 15,
        fill: "#FFC95B"
    })), _circle3 || (_circle3 = /*#__PURE__*/ React.createElement("circle", {
        cx: 42.51,
        cy: 22.5,
        r: 7.5,
        fill: "#FFC95B"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_1733_3230",
        x1: 60,
        x2: -24.852,
        y1: -24.852,
        y2: 60,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FF2D55"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FFBC5B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_1733_3230",
        x1: 42.497,
        x2: 42.497,
        y1: 39,
        y2: 84,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#A524B3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FF2D55"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint2_linear_1733_3230",
        x1: 80.481,
        x2: 80.481,
        y1: 63,
        y2: 96,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#A524B3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FF2D55"
    })))));
};

export { SvgMana as ReactComponent };
//# sourceMappingURL=MANA.svg.es.js.map
